(function() {
  var linkedVariants = window.__linkedVariants__;
  if (!linkedVariants) return;

  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input.matches('input[name*="option1"]')) return;

    var label = document.querySelector('label[for="' + input.id + '"]');
    var sizeValue = label ? label.textContent.trim() : input.value.trim();
    var url = linkedVariants[sizeValue];

    if (url && window.location.pathname !== url) {
      window.location.href = url;
    }
  });
})();
